<!-- public 公共页面 -->
<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      :page="page"
      ref="crud"
      @row-del="rowDel"
      v-model="form"
      @row-update="rowUpdate"
      @row-save="rowSave"
      :before-open="beforeOpen"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @refresh-change="refreshChange"
    >
      <template slot-scope="scope" slot="menu">
        <el-button type="success" 
            icon="el-icon-top-left"
            size="mini"
            @click.stop="handleGoTo(scope.row,scope.index)">前往</el-button>
      </template>
    </avue-crud>
  </basic-container>
</template>
<script>
import {getList,saveOpRunLog} from "@/api/system/public";
export default {
  components: {},
  data() {
    return {
      id:"",
      folderId:"",
      name:"",
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      selectionList: [],
      option: {
        height: "auto",
        calcHeight: 100,
        dialogWidth: 950,
        tip: false,
        menuWidth:"auto",
        searchShow: true,
        searchMenuSpan: 6,
        border: true,
        refreshBtn:false,
        columnBtn:false,
        index: true,
        viewBtn: false,
        delBtn: false, //行删除按钮
        addBtn: false,
        editBtn: false,
        selection: false,  //多选
        excelBtn: false, //打印按钮
        dialogClickModal: false,
        column: [
          {
            label: "服务器",
            prop: "appserverName",
            span: 24,
            row: true,
          },
          {
            label: "数据库",
            prop: "dbName",
            span: 24,
            row: true,
          },
          {
            label: "模块名",
            prop: "opName",
            span: 24,
            row: true,
          },
          {
            label: "角色名",
            prop: "roleName",
            span: 24,
            row: true,
          },
          {
            label: "框架",
            prop: "systemName",
            span: 24,
            row: true,
          },
          {
            label: "组名",
            prop: "teamName",
            span: 24,
            row: true,
          },
          {
            label: "路径",
            prop: "path",
            span: 24,
            row: true,
          },
        ]
      },
      data: []
    };
  },
  computed: {},
  watch: {},
  methods: {
      handleGoTo(row) {
        this.loading = true;
        saveOpRunLog(this.$qs.stringify({jsonObj:JSON.stringify(row)})).then(res => {
          const data = res.data.data;
          this.$router.replace({
            path:row.path,
            query:{
              runId:data.runId,
              name:this.name,
              relatedTablePk: this.$route.query.relatedTablePk,
              relatedOp: this.$route.query.relatedOp
            }
          })
          this.loading = false;
        },err => {
          this.loading = false;
        });
      },
      searchReset() {
        this.query = {};
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page, params = {}) {
        const {releaseTimeRange} = params;
        let values = {
          ...params
        };
        this.loading = true;
        getList({opid:this.id,folderId:this.folderId}).then(res => {
          const data = res.data.data;
          if(data.opsEntities.length==1){
              this.$router.replace({
                path:data.opsEntities[0].path,
                query:{
                  runId:data.opsEntities[0].runId,
                  name:this.name,
                  relatedTablePk: this.$route.query.relatedTablePk,
                  relatedOp: this.$route.query.relatedOp
                }
              })
              this.loading = false;
          }else{
            this.data=data.opsEntities;
          }
          this.loading = false;
        },
        err => {});
      }
    },
  created() {},
  mounted() {},
  beforeRouteUpdate (to, from, next) {
    this.id=to.params.opid;
    this.name=to.params.name;
    this.folderId=to.params.folderId;
    if(this.folderId==="null"){
      this.folderId="";
    }
    this.onLoad() // 重新加载数据
    next();
  },
  activated() {
    this.id=this.$route.params.opid;
    this.name=this.$route.params.name;
    this.folderId=this.$route.params.folderId;
    if(this.folderId==="null"){
      this.folderId="";
    }
    this.onLoad()
  }
};
</script>
<style lang='scss' scoped>
</style>
